export default __webpack_public_path__ + "static/devops_automation_tab_image-f8e0c112d15b60298f773fa6aadecb13.svg";